import { InternalTranslationContext } from './context';
import { createTranslation } from './utils';
import React from 'react';

export const useTranslation = (namespace?: string) => {
  const { namespaces, lang, defaultNS } = React.useContext(InternalTranslationContext);
  return {
    t: createTranslation(namespaces?.[namespace ?? defaultNS ?? 'common'] ?? {}),
    lang,
  };
};

export default useTranslation;
